<template>
	<v-menu offset-y  :close-on-content-click = "false">	    		
	    <template v-slot:activator = "{ on, attrs }">	    			
			<v-btn small v-on="on" v-bind="attrs">
			    <v-tooltip bottom>
			    	<template v-slot:activator = "{ on, attrs}">			    				
			    		<v-icon small v-on="on" v-bind="attrs">mdi-file-cog</v-icon>
			    	</template>
			    	<span> {{ $ml.get('dashboard') }} </span>
			    </v-tooltip>
			</v-btn>
			<!-- dashboard_item. -->
			<v-dialog v-model="dialog" width="450" persistent ref="MenuFormDashboard">
				<FormModalDashboard :typeForm="typeForm" :isDialogActive="dialog" :renderDashboards="renderDashboards" :currentProfile="currentProfile" @closeModal="renderCloseModal()"></FormModalDashboard>
	    	</v-dialog>
		</template>
		<v-list dense>
			<v-list-item-group dense>
				<v-list-item dense 	    				
					v-show = "is_user && currentRoute != 'setting_device'"
					:disabled = "true"
				>
					<v-list-item-icon class = "pa-0 mx-0 mr-1 ">
						<v-icon small color="primary">mdi-file-plus</v-icon>
					</v-list-item-icon>
	    			<v-list-item-content>
	    				<v-list-item-title>		    					
			    			{{ $ml.get("dashboard") + " : "}} {{ defaultDashboard ? defaultDashboard.name : $ml.get("default") }}
			    			<!-- currentProfile.id ? :-->
	    				</v-list-item-title>
	    			</v-list-item-content>
				</v-list-item>	   
				<v-divider></v-divider>
				<!-- save_profile -->
	    		<v-list-item dense @click="confirmSave()" 
					v-show = "is_user && is_user.user.roleId < 3 && currentRoute !== 'setting_device' && showToProfile.save_dashboard"
				>
					<v-list-item-icon class = "pa-0 mx-0 mr-1 ">
						<v-icon small color="primary">mdi-file-plus</v-icon>
					</v-list-item-icon>
	    			<v-list-item-content>
	    				<v-list-item-title>
	    					{{ $ml.get('save') }} 
	    				</v-list-item-title>
	    			</v-list-item-content>
				</v-list-item>
				
				<!-- create_new_dashboard -->
	    		<v-list-item dense @click="createNewDashboard()" 
					v-show = "is_user && is_user.user.roleId < 3 && currentRoute !== 'setting_device'"
				>
					<v-list-item-icon class = "pa-0 mx-0 mr-1 ">
						<v-icon small color="success">mdi-plus-circle</v-icon>
					</v-list-item-icon>
	    			<v-list-item-content>
	    				<v-list-item-title>
	    					{{ $ml.get('create_new') }} {{ $ml.get('dashboard') }}
	    				</v-list-item-title>
	    			</v-list-item-content>
				</v-list-item>	   
	    		<v-divider></v-divider> 				 

	    		<!-- ***********************  Dashboard   ************************************+  -->
	    		<!-- send_profile -->
				<v-list-item dense 
					@click = "selectProfile()" 
					v-show = "(!showToProfile.dashboards && currentRoute != 'setting_device') && is_user &&  is_user.user && is_user.user.roleId < 3 "
				>
					<v-list-item-icon class="pa-0 mx-0 mr-1">
						<v-icon small color="grey">mdi-clipboard-list</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							{{ $ml.get('dashboard') }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>	  

				<!-- *********** Delete_profile **************** -->
				<!-- to_del_profile 
					{
						name : dashboard_selected.name || $ml.get('default')}, 
						get_name_profile(currentRoute),
						true
				-->
				<v-list-item dense 
					@click = "clearProfile(currentProfile)" 
					v-show = "(showToProfile.dashboards || currentRoute == 'face' ) && is_user && is_user.user.roleId < 3"
				>
					<v-list-item-icon class = "pa-0 mx-0 mr-1 ">
						<v-icon small color="error">mdi-clipboard-list</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title> {{ $ml.get('clean_dashboard') }} </v-list-item-title>
					</v-list-item-content>
				</v-list-item>	 
					

				<!-- ********************** list profile dashboards  ************************** -->

				<!-- || $router.currentRoute.name=='setting_device' -->
				<v-list-group v-show = "showToProfile.dashboards">
					<template v-slot:activator>						 	
			        	<v-list-item-icon class="pa-0 mx-0 mr-1">
			        		<v-icon small>mdi-view-dashboard</v-icon>
			        	</v-list-item-icon>
			        	<v-list-item-content>
			        		<!-- style = "max-width:145px" -->
				          	<v-list-item-title class = "caption d-flex" :max-width="'145px'">{{$ml.get('dashboards')}}</v-list-item-title>	
			         	</v-list-item-content>
			        </template>
			        <v-list dense flat>
				        <v-list-item-group dense>
				        	<!-- list_dashboards -->
				        	<v-list-item dense class="pl-8" v-for="(item_profile, index) of renderDashboards" :key="index">
				      			<v-list-item-icon class="pa-0 mx-0 mr-1" @click.stop="selectProfile(item_profile)">
					      			<v-icon small>mdi-clipboard-list</v-icon>
					      		</v-list-item-icon>
					      		<!-- send_profile -->
					      		<v-list-item-content @click.stop="selectProfile(item_profile)">
					      			<!-- style="height : 15px" -->
					      			<v-list-item-title class="caption mb-0" :height="'15px'">{{ item_profile.name }}</v-list-item-title>
					              <!-- <v-list-item-subtitle class="caption d-flex" style="max-width:145px"> {{ item_profile.name}}</v-list-item-subtitle>				               -->
					            </v-list-item-content>
					            <!-- send_profile(item_profile, true, list_dashboards ) -->
				              	<v-list-item-action v-if = "is_user && is_user.user.roleId < 3">
				            		<v-btn-toggle dense>
				            			<!-- Botón para marcar como default -->
				            			<v-tooltip top>
				            				<template v-slot:activator="{ on, attrs }">
						              			<span v-on="on" v-bind="attrs">
						              				<v-icon
						              					small
						              					:color="item_profile.state === 'default' ? 'yellow darken-3' : 'grey'"
						              					@click.stop="setDefaultDashboard(item_profile)"
						              				>
						              					mdi-star
						              				</v-icon>
						              			</span>
					            			</template>
				            			<span>{{ $ml.get('set_default') }}</span>
				            		</v-tooltip>
				            			<span style="width: 12px; display: inline-block;"></span>
				            			<!-- Botón update (más visible) -->
				            			<v-tooltip top>
				            				<template v-slot:activator = "{ on, attrs }">
						              			<v-icon small v-show = "showToProfile.edit"
						              				class  = "mr-1" 
						              				color  = "primary" 
						              				v-on   = "on"
						              				v-bind = "attrs"
						              				@click.stop  = "confirmUpdate(item_profile)"
						              			>
						              				mdi-pencil
						              			</v-icon>
					            			</template>
				            			<span> {{ $ml.get('edit') }} </span>
				            		</v-tooltip>
				            			<span style="width: 12px; display: inline-block;"></span>
				            			<!-- Botón duplicar -->
				            			<v-tooltip top>
				            				<template v-slot:activator = "{ on, attrs }">
						              			<v-icon small v-show = "showToProfile.edit"
						              				class  = "mr-1" 
						              				color  = "info" 
						              				v-on   = "on"
						              				v-bind = "attrs"
						              				@click.stop  = "duplicateDashboard(item_profile)"
						              			>
						              				mdi-content-copy
						              			</v-icon>
					            			</template>
				            			<span> {{ $ml.get('duplicate') || 'Duplicar' }} </span>
				            		</v-tooltip>
				            			<span style="width: 12px; display: inline-block;"></span>
				            			<!-- Botón eliminar -->
				            			<v-tooltip top>
				            				<template v-slot:activator = "{ on, attrs }">   		
				            					<v-icon 
				            						small 
				            						v-show = "showToProfile.delete"
				            						color  = "error" 
				            						v-on   = "on"
				            						v-bind="attrs"
				            						@click.stop = "confirmDelete(item_profile)"
				            					>
				            						mdi-delete
				            					</v-icon>
				            				</template>
				            				<span> {{ $ml.get('delete') }} </span>
				            			</v-tooltip>
				              		</v-btn-toggle>
				              </v-list-item-action>
					      	</v-list-item>
					      	<!-- check_len(list_dashboards[currentRoute]) -->
					      	<v-list-item v-show = "renderDashboards.length == 0">
					      		<v-list-item-icon>
					      			<v-icon small>mdi-clipboard-alert</v-icon>
					      		</v-list-item-icon>
					      		<v-list-item-content>
					      			<v-list-item-title> {{ $ml.get('no_data') }} </v-list-item-title>
					      		</v-list-item-content>
					      	</v-list-item>
				        </v-list-item-group> 
			    	</v-list>
				</v-list-group> 				    	
			</v-list-item-group>
		</v-list>
		
	</v-menu>
</template>
<script type="text/javascript">
	import FormModalDashboard from "@/components/dashboard/FormModalDashboard.vue"
	export default{
		name : "MenuOptionsDashboard",
		components:{ FormModalDashboard },
		props: ["is_user", "currentRoute", "showToProfile", "alertMode"],
		data : (vm)=>({			
			menu : false,			
			dialog : false,
			infoItem: null,
			typeForm : "",
			loadingDashboard : false,
			originalProfile: null,      // Nuevo: para guardar el estado original
			editProfile: null,          // Nuevo: para edición temporal
		}),
		created(){
			this.getList();
			// Verificar redirección a dashboard default en caso de recarga (F5)
			this.$nextTick(() => {
				this.checkAndRedirectToDefault();
			});
		},
		watch:{
			currentRoute(val){
				if (val == 'dashboard') {
					this.checkAndRedirectToDefault();
				} else if (val == 'dashboards') { // redirect dashboards with id
					this.currentProfile.dashboard=[];
					this.renderLoadDashboard();
				}
			}
		},
		computed:{
			currentProfile:{
				get(){
					return this.$store.getters["Dashboard/getCurrentProfile"]
				},
				set(value){
					this.$store.commit("Dashboard/setCurrentProfile", value);	
				}
			},
			renderDashboards(){
				return this.$store.getters["Dashboard/getList"];
			},
			// Nuevo: dashboard por defecto
			defaultDashboard() {
				return this.renderDashboards.find(dash => dash.state === 'default');
			}
		},
		methods:{
			checkAndRedirectToDefault() {
				
				
				// Solo verificar si estamos en la ruta /dashboard (sin ID)
				if (this.$route.path !== '/dashboard') {
					
					return;
				}
				
				this.$store.dispatch('Dashboard/getList').then(() => {
					const dashboards = this.$store.getters['Dashboard/getList'];
					const defaultDashboard = dashboards.find(d => d.state === 'default');
					
					if (defaultDashboard) {
						
						// Verificar si ya estamos en la ruta de destino para evitar redirecciones innecesarias
						const targetPath = `/dashboard/${defaultDashboard.id}`;
						if (this.$route.path === targetPath) {
							return;
						}
						
						this.$router.replace({ name: 'dashboards', params: { id: defaultDashboard.id }})
							.then(() => {})
							.catch(error => {
								if (error.name !== 'NavigationDuplicated') {
									console.error("❌ ERROR en redirección a dashboard default:", error);
								}
							});
					} else {
						this.confirmOptionProfile();
					}
				}).catch(error => {
					console.error("❌ ERROR al cargar lista de dashboards:", error);
				});
			},
			
			renderGrid(){
				
			},
			renderCloseModal(item){
				this.dialog = false;
				
				// Limpiar el estado de edición
				this.originalProfile = null;
				this.editProfile = null;
				
				if (this.typeForm=="confirm_dashboard") {
					if (this.currentProfile.dashboard && this.currentProfile.dashboard.length==0 && !item) {
						this.renderLoadDashboard();
					}
					this.typeForm="";
				}
			},
			async renderLoadDashboard(){
				// if (this.currentProfile && this.currentProfile.dashboard && this.currentProfile.dashboard.length == 0) {	// layout
				// if(!this.loadingDashboard){
					this.loadingDashboard=true;
				    this.$EventBus.$emit('status_steps_loading', this.$ml.get('loading_dashboard_profile'));
				    if(!this.$store.getters["Dashboard/getIsLoaded"]){
						await this.$store.dispatch("Dashboard/getList").then(res=>{}).catch(error=>{})
					}
					let loading_layouts = setTimeout( () => {
						this.$store.dispatch("Dashboard/loadLocalProfile", this.$route.params).then(res=>{	
						// console.log("LOADED Dashboard ===========================", res)					
					    	this.$store.commit("Dashboard/checkPositions");
				    		this.$EventBus.$emit('status_steps_loading', this.$ml.get('loaded_dashboard_profile'));
				    		this.$EventBus.$emit('status_steps_loading', false);
							this.loadingDashboard=false;
						})			
						clearTimeout(loading_layouts);
					}, 2500);
				// }
					
				// }		
			},
			selectProfile(item){
				console.log("🔄 Seleccionando dashboard desde el menú", item);
				
				if (!item) {
					console.error("❌ ERROR: Item es null o undefined");
					return;
				}
				
				if (!item.id) {
					console.error("❌ ERROR: Dashboard no tiene ID", item);
					return;
				}
				
				try {
					// Simplemente cargar el dashboard sin cambiar su state
					console.log("📂 Cargando dashboard:", item.name, "ID:", item.id);
					
					// Actualizar el currentProfile en el store sin cambiar el estado
					this.currentProfile = { ...item };
					this.loadingDashboard = false;
					this.currentProfile.dashboard = [];
					
					const target = `/dashboard/${item.id}`;
					console.log("🔄 Navegando a:", target);
					
					// Verificar si ya estamos en la ruta correcta
					if (this.$route.path === target) {
						console.log("🔄 Ya estamos en la ruta correcta, solo cargando dashboard...");
						this.$store.dispatch("Dashboard/loadLocalProfile", { id: item.id })
							.then(() => {
								console.log("✅ Dashboard cargado exitosamente");
							})
							.catch(error => {
								console.error("❌ ERROR cargando dashboard:", error);
							});
					} else {
						console.log("🚀 Redirigiendo a nueva ruta...");
						this.$router.push({ name: 'dashboards', params: { id: item.id }})
							.then(() => {
								console.log("✅ Navegación exitosa");
								// Cargar el dashboard después de navegar
								this.$store.dispatch("Dashboard/loadLocalProfile", { id: item.id })
									.then(() => {
										console.log("✅ Dashboard cargado exitosamente");
									})
									.catch(error => {
										console.error("❌ ERROR cargando dashboard:", error);
									});
							})
							.catch(error => {
								// Capturar NavigationDuplicated y otros errores de navegación
								if (error.name === 'NavigationDuplicated') {
									console.log("ℹ️ NavigationDuplicated ignorado - ya estamos en la ruta");
									// Aún así cargar el dashboard
									this.$store.dispatch("Dashboard/loadLocalProfile", { id: item.id })
										.then(() => {
											console.log("✅ Dashboard cargado exitosamente");
										})
										.catch(loadError => {
											console.error("❌ ERROR cargando dashboard:", loadError);
										});
								} else {
									console.error("❌ ERROR en navegación:", error);
								}
							});
					}
				} catch (error) {
					console.error("❌ ERROR GENERAL en selectProfile:", error);
					this.$EventBus.$emit('notifications_modal', {
						type: 'error',
						message: 'Error inesperado al seleccionar el dashboard'
					});
				}
			},
				
			confirmSave(){
				console.log("💾 Intentando guardar dashboard actual...");
				
				if (this.currentProfile.dashboard && this.currentProfile.dashboard.length) {
					console.log("✅ Dashboard tiene componentes, abriendo modal de guardado");
					this.dialog=true;
					this.typeForm="create";
				}else{
					console.log("⚠️ Dashboard está vacío, mostrando advertencia");
					this.$EventBus.$emit('notifications_modal',{
    					type 	: 'warning',
    					message : this.$ml.get('ms_dashboard_empty') || 'El dashboard está vacío. Agrega algunos componentes antes de guardarlo.'
    				});
				}				
			},
			hasUnsavedChanges() {
				// Si no hay estado original, no hay cambios no guardados
				if (!this.originalProfile) {
					return false;
				}
				
				// Si no hay perfil actual, no hay cambios
				if (!this.currentProfile) {
					return false;
				}
				
				// Comparar el estado actual con el estado original del servidor
				const currentState = {
					name: this.currentProfile.name,
					alertMode: this.currentProfile.alertMode,
					dashboard: this.currentProfile.dashboard,
					options: this.currentProfile.options,
					camVisibility: this.currentProfile.camVisibility
				};
				
				const originalState = {
					name: this.originalProfile.name,
					alertMode: this.originalProfile.alertMode,
					dashboard: this.originalProfile.dashboard,
					options: this.originalProfile.options,
					camVisibility: this.originalProfile.camVisibility
				};
				
				const hasChanges = JSON.stringify(currentState) !== JSON.stringify(originalState);
				
				if (hasChanges) {
					console.log('⚠️ Cambios no guardados detectados:', {
						original: originalState,
						current: currentState
					});
				}
				
				return hasChanges;
			},
			async saveCurrentChanges() {
				// Guardar los cambios actuales del perfil en el servidor
				if (this.currentProfile && this.currentProfile.id) {
					try {
						// Emitir evento para obtener camVisibility del componente parking
						this.$EventBus.$emit('getCamVisibility');
						
						// Esperar un poco para que el componente responda
						await new Promise(resolve => setTimeout(resolve, 100));
						
						// Obtener camVisibility del store
						const camVisibility = this.$store.getters['Dashboard/camVisibility'] || {};
						
						// Preparar los datos para guardar
						const dataToSave = {
							...this.currentProfile,
							camVisibility
						};
						
						// Actualizar en el servidor
						const result = await this.$store.dispatch("Dashboard/updateList", dataToSave);
						
						if (result && result.data) {
							console.log('✅ Cambios guardados exitosamente');
							return Promise.resolve();
						} else {
							throw new Error('Error al guardar cambios');
						}
					} catch (error) {
						console.error('❌ Error al guardar cambios:', error);
						return Promise.reject(error);
					}
				}
				return Promise.resolve();
			},
			confirmUpdate(item) {
				// Verificar si hay cambios no guardados en el dashboard actual
				if (this.hasUnsavedChanges()) {
					this.$EventBus.$emit("notifications_modal", {
						type: "confirm_options",
						message: "Tienes cambios no guardados en el dashboard actual. ¿Qué deseas hacer?",
						options: [
							{
								text: "Guardar cambios y editar",
								action: () => {
									// Primero guardar los cambios actuales, luego editar
									this.saveCurrentChanges().then(() => {
										this.forceEditDashboard(item);
									}).catch(() => {
										// Si falla el guardado, preguntar si quiere continuar sin guardar
										this.$EventBus.$emit("notifications_modal", {
											type: "confirm_options",
											message: "No se pudieron guardar los cambios. ¿Deseas continuar editando sin guardar?",
						Action: () => {
							this.forceEditDashboard(item);
						}
										});
									});
								}
							},
							{
								text: "Descartar cambios y editar",
								action: () => {
									this.forceEditDashboard(item);
								}
							},
							{
								text: "Cancelar",
								action: () => {
									// No hacer nada, mantener el estado actual
								}
							}
						]
					});
				} else {
					// No hay cambios no guardados, proceder directamente
					this.forceEditDashboard(item);
				}
			},
			forceEditDashboard(item) {
				// Guardar el estado original del servidor para comparación
				this.originalProfile = { ...item };
				
				// Usar la nueva acción del store para preparar el dashboard para edición
				this.$store.dispatch('Dashboard/prepareForEdit', item.id).then((dashboardForEdit) => {
					this.editProfile = { ...dashboardForEdit };
					this.currentProfile = this.editProfile;
					this.dialog = true;
					this.typeForm = "update";
					
					console.log('🔧 Dashboard preparado para edición:', dashboardForEdit);
				}).catch((error) => {
					console.error('❌ Error al preparar dashboard para edición:', error);
					// Fallback: usar el método anterior
					let currentState = null;
					if (this.currentProfile && this.currentProfile.id === item.id) {
						currentState = { ...this.currentProfile };
					} else {
						currentState = { ...item };
					}
					
					this.editProfile = currentState;
					this.currentProfile = this.editProfile;
				this.dialog = true;
				this.typeForm = "update";
				});
			},
			confirmOptionProfile(){
				this.dialog = true;
				this.typeForm = "confirm_dashboard";
			},
			
			createNewDashboard() {
				console.log("🆕 Creando nuevo dashboard...");
				
				// Limpiar el dashboard actual para empezar limpio
				this.$store.commit("Dashboard/setProfile", []);
				this.$store.commit("Dashboard/setPositionX", 0);
				this.$store.commit("Dashboard/setPositionY", 0);
				
				// Establecer un perfil temporal vacío
				const emptyProfile = {
					name: "",
					alertMode: "snack",
					dashboard: [],
					options: {
						draggable: false,
						resizable: true,
						prevent_collision: false,
						vertical_compact: false,
					},
					camVisibility: {}
				};
				
				this.currentProfile = emptyProfile;
				this.originalProfile = null; // Resetear el estado original
				
				// Abrir el modal de creación
				this.dialog = true;
				this.typeForm = "create";
				
				console.log("✅ Dashboard vacío preparado para creación");
			},

			clearProfile(item){
				if (item) {					
					this.$EventBus.$emit("notifications_modal", { 
						type : "confirm_options", 
						ID : "MenuProfileDashboardClear",
						message : this.$ml.get("clean_dashboard") + " " + (item.id? item.name : this.$ml.get("default")),
						Action : this.clearItem, 
					})
				}
			},
			confirmDelete(item){		
				if (item) {					
					this.infoItem=item;
					this.$EventBus.$emit("notifications_modal", { 
						type : "confirm_delete", 
						ID : "MenuProfileDashboard",
						message : this.$ml.get("dashboard") + " " + (item.id? item.name : this.$ml.get("default")),
						Action : this.deleteItem, 

					})
				}	
			},
			async getList(){
				//console.log("📋 Cargando lista de dashboards...");
				try{
					if(!this.$store.getters["Dashboard/getIsLoaded"]){
						await this.$store.dispatch("Dashboard/getList").then(res=>{
							//console.log("✅ Lista de dashboards cargada exitosamente");
						}).catch(error=>{
							//console.error("❌ ERROR cargando lista de dashboards:", error);
						})
					} else {
						//console.log("ℹ️ Lista de dashboards ya estaba cargada");
					}
				}catch(error){
					//console.error("❌ ERROR GENERAL en getList:", error);
				}finally{
					// this.loading=false;
				}
			},
			
			async refreshDashboardList() {
				//console.log("🔄 Refrescando lista de dashboards...");
				try {
					// Forzar recarga de la lista
					this.$store.commit("Dashboard/setIsLoaded", false);
					await this.$store.dispatch("Dashboard/getList");
				//	console.log("✅ Lista de dashboards refrescada");
				} catch (error) {
				//	console.error("❌ ERROR refrescando lista:", error);
				}
			},
			
			deleteItem(val){
				if (val) {
					if (this.infoItem && this.infoItem.id) {						
						this.$EventBus.$emit("notifications_modal", {
							type 	: "primary",
							message : this.$ml.get("deleting_dashboard"),
							loading : true,
						})
		        		this.$store.dispatch("Dashboard/deleteList",{
		        			...this.infoItem,
		        		}).then(res=>{
		        			if (res &&  res.data) {        				        				
		        				// this.$store.commit("Dashboard/setCurrentProfile", {...info_up});        				
		        				// this.renderAlertMode();
		        				if (this.currentProfile && this.currentProfile.id && this.currentProfile.id == this.infoItem.id && this.currentRoute == 'dashboards') {
			        				this.$router.push({ name : "dashboard" });
		        				}
			        			this.$EventBus.$emit('notifications_modal',{
				        			type 	: 'deleted',
				        			message :  this.$ml.get('dashboard') + ": " + this.infoItem?.name || ""
				        		});
		        			}
		        		}).catch(error=>{
		        			console.log("Error delete dashboard : ", error);

		        		})
					}else{
						this.$store.commit("Dashboard/setProfile", []);
						if (this.currentRoute == 'dashboards') {
							this.$router.push({ name : "dashboard" });
						}
					}
				}
			},
			clearItem(val){
				if (val) {
					// Limpiar completamente el dashboard actual sin redirigir al default
					this.$store.commit("Dashboard/setProfile", []);
					this.$store.commit("Dashboard/setPositionX", 0);
					this.$store.commit("Dashboard/setPositionY", 0);
					this.$store.commit("Dashboard/saveLocalProfile");
					
					// Preparar flujo de creación de un nuevo dashboard
					this.createNewDashboard();
				}
			},
			setDefaultDashboard(item) {
				//console.log("⭐ Estableciendo dashboard como default:", item.name);
				
				// Cambia todos los dashboards a 'active' excepto el seleccionado
				this.renderDashboards.forEach(dash => {
					if (dash.id !== item.id) {
						console.log("📝 Cambiando dashboard", dash.name, "a active");
						this.$store.dispatch("Dashboard/updateList", { ...dash, state: 'active' })
							.catch(error => {
								console.error("❌ ERROR actualizando dashboard a active:", dash.name, error);
							});
					}
				});

				// Cambia el dashboard seleccionado a 'default'
				this.$store.dispatch("Dashboard/updateList", { ...item, state: 'default' })
					.then(() => {
						console.log("✅ Dashboard establecido como default exitosamente");
						this.currentProfile = { ...item, state: 'default' };
						this.$EventBus.$emit('notifications_modal',{
							type   : 'updated',
							message:  this.$ml.get('dashboard') + ' ' + this.$ml.get('set_default')
						});
					})
					.catch(error => {
						console.error("❌ ERROR estableciendo dashboard como default:", error);
						this.$EventBus.$emit('notifications_modal',{
							type   : 'error',
							message:  'Error al establecer dashboard como default: ' + error.message
						});
					});
			},
			duplicateDashboard(item) {
				console.log("🔄 Duplicando dashboard:", item.name);
				
				// Crear una copia profunda del dashboard
				const newDashboard = JSON.parse(JSON.stringify(item));
				newDashboard.name = `${item.name} - ${this.$ml.get('copy') || 'Copia'}`;
				delete newDashboard.id; // Eliminar ID para crear uno nuevo
				newDashboard.state = 'active'; // Establecer como activo (no default)
				
				this.$EventBus.$emit("notifications_modal", {
					type: "confirm_options",
					message: `¿Estás seguro de que quieres duplicar el dashboard "${item.name}"?`,
					options: [
						{
							text: "Sí, duplicar",
							action: () => {
								this.$EventBus.$emit("notifications_modal", {
									type: "primary",
									message: "Duplicando dashboard...",
									loading: true,
								});
								
								console.log("💾 Guardando dashboard duplicado...");
								this.$store.dispatch("Dashboard/saveList", newDashboard)
									.then(res => {
										if (res && res.data) {
											console.log("✅ Dashboard duplicado exitosamente");
											this.$EventBus.$emit('notifications_modal', {
												type: 'success',
												message: `Dashboard "${newDashboard.name}" creado exitosamente`
											});
											// Refrescar la lista
											this.refreshDashboardList();
										}
									})
									.catch(error => {
										console.error("❌ ERROR duplicando dashboard:", error);
										this.$EventBus.$emit('notifications_modal', {
											type: 'error',
											message: 'Error al duplicar el dashboard: ' + (error.message || error)
										});
									});
							}
						},
						{
							text: "No, cancelar",
							action: () => {
								console.log("❌ Duplicación cancelada por el usuario");
							}
						}
					]
				});
			}
		},

	}
</script>
